const authProvider = {
    // ログイン処理
    login: async ({ username, password }) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_DIR}/auth/login`, {
                method: "POST",
                body: JSON.stringify({ username, password }),
                mode: "cors",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
            });

            console.log("Login Response:", response);

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`ログインに失敗しました (${response.status}): ${errorText}`);
            }

            const json = await response.json();
            console.log("Login JSON:", json);

            if (json.isError) {
                throw new Error(json.message || "ログインに失敗しました");
            }
        } catch (error) {
            console.error("Login Fetch Error:", error);
            throw error;
        }
    },

    // ログアウト処理
    logout: async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_DIR}/auth/logout`, {
                method: "GET",
                mode: "cors",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
            });

            console.log("Logout Response:", response);

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`ログアウトに失敗しました (${response.status}): ${errorText}`);
            }

            const json = await response.json();
            console.log("Logout JSON:", json);

            if (json.isError) {
                throw new Error(json.message || "ログアウトに失敗しました");
            }
        } catch (error) {
            console.error("Logout Fetch Error:", error);
            throw error;
        }
    },

    // 認証チェック
    checkAuth: async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_DIR}/auth/check`, {
                method: "GET",
                mode: "cors",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
            });

            console.log("Check Auth Response:", response);

            if (!response.ok) {
                const errorText = await response.text();
                console.error("Check Auth Error:", errorText);
                return Promise.reject({ redirectTo: "/login", error: errorText });
            }

            const { data } = await response.json();
            console.log("Check Auth JSON:", data);

            if (!data) {
                return Promise.reject({ redirectTo: "/login" });
            }
        } catch (error) {
            console.error("Check Auth Fetch Error:", error);
            return Promise.reject({ redirectTo: "/login", error });
        }
    },

    // ユーザー権限チェック（必要に応じて実装）
    getPermissions: async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_DIR}/auth/permission`, {
                method: "GET",
                mode: "cors",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
            });

            console.log("Get Permissions Response:", response);

            if (!response.ok) {
                const errorText = await response.text();
                console.error("Get Permissions Error:", errorText);
                return Promise.reject({ redirectTo: "/login", error: errorText });
            }

            const { data } = await response.json();
            console.log("Get Permissions JSON:", data);

            if (data < 0) {
                return Promise.reject({ redirectTo: "/login" });
            }
            return Promise.resolve(data);
        } catch (error) {
            console.error("Get Permissions Fetch Error:", error);
            return Promise.reject(error);
        }
    },

    checkError: async (error) => {
        console.error("Check Error:", error);
        if (error.status === 401 || error.status === 403) {
            return Promise.reject(); // 認証エラーならログアウト
        }
        return Promise.resolve();
    },
};

export default authProvider;
